// extracted by mini-css-extract-plugin
export var typingIndicator = "_o9-0";